
    import { Component, Vue } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import PrePlanForm from './pre-plan-manage.vue'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import DateUtils from '@/common/js/DateUtils'
    import moment from 'moment'

    // 定义下拉框选项类型
    interface SelectOption {
        value: boolean | null;
        label: string;
    }

    // 定义查询参数模型
    class PrePlanSearchRequest extends PageRequest {
        userId?: number;
        startDate?: Date;
        endDate?: Date;
        productInternalCode: string = '';
        logisticsNumber: string = '';
        boxBatchNumber: string = '';
        planNumber: string = '';
        shippingMark: string = '';
        isSelf?: boolean | null; // 允许为null（全部）
        storeId?: number | null; // 允许为null（全部）
        isProcessed?: boolean | null; // 允许为null（全部）
        productId: string = '';
    }

    // 定义复合表模型
    interface PlanWarehouseStock {
        prePlanId: number;
        productId: number;
        productNums: number;
        logisticsNumber: string;
        productStatus?: number;
        boxNumber: number;
        inStockNumber: string;
    }

    interface PlanPackingDetail {
        packingPlanId: number;
        productId: number;
        boxNumber: number;
        productNums: number;
        creationTime: Date;
    }

    interface PackingPlanList {
        id: number;
        userCode: string;
        planNumber: string;
        creationTime: Date;
        remark: string;
        storeId: number;
        storeName: string;
        isSelf: boolean;
        isProcess: boolean;
        shippingMark: string;
        boxBatchNumber: string;
        planWarehouseStocks: PlanWarehouseStock[];
        planPackingDetails: PlanPackingDetail[];
        packingPlanId?: number;
    }

    @Component({
        name: "preplannanager",
        components: { PrePlanForm }
    })
    export default class PrePlanManager extends AbpBase {
        // 弹窗控制
        modalShow: boolean = false;
        // 仓库列表（含全部）
        storeaddressList: Array<storeaddressInfo> = [];
        // 查询参数
        pagerequest: PrePlanSearchRequest = new PrePlanSearchRequest();
        // 日期范围
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        // 产品状态枚举
        ProductStatus = Enums.getEnum(Enums.ProductStatus, true);
        // 是否自装箱下拉选项（含全部）
        IsSelfOptions: SelectOption[] = [
            { value: null, label: '全部' },
            { value: true, label: '是' },
            { value: false, label: '否' }
        ];
        // 是否已处理下拉选项（含全部）
        IsProcessedOptions: SelectOption[] = [
            { value: null, label: '全部' },
            { value: true, label: '是' },
            { value: false, label: '否' }
        ];

        // 获取列表数据
        get list(): PackingPlanList[] {
            return this.$store.state.frontpreplan.list;
        };

        // 获取加载状态
        get loading(): boolean {
            return this.$store.state.frontpreplan.loading;
        }

        // 获取分页参数
        get pageSize(): number {
            return this.$store.state.frontpreplan.pageSize;
        }

        get totalCount(): number {
            return this.$store.state.frontpreplan.totalCount;
        }

        get currentPage(): number {
            return this.$store.state.frontpreplan.currentPage;
        }

        // 列配置
        columns = [
            {
                title: '基本信息',
                width: 250,
                fixed: 'left',
                render: (h: any, params: any) => {
                    const row = params.row;
                    return h('div', [
                        h('h3', `计划单号：${row.planNumber || ''}`),
                        h('h3', `用户编码：${row.userCode || ''}`),
                        h('h3', `仓库名称：${row.storeName || ''}`),
                        h('h3', `是否自装箱：${row.isSelf ? '是' : '否'}`),
                        h('h3', `是否已处理：${row.isProcess ? '是' : '否'}`),
                        h('h3', `创建时间：${DateUtils.formatLongDate(new Date(row.creationTime))}`)
                    ]);
                }
            },
            {
                title: '装箱信息',
                width: 200,
                render: (h: any, params: any) => {
                    const row = params.row;
                    return h('div', [
                        h('h3', `唛头：${row.shippingMark || ''}`),
                        h('h3', `装箱批次号：${row.boxBatchNumber || ''}`),
                        h('h3', `备注：${row.remark || '无'}`)
                    ]);
                }
            },
            {
                title: '入库单记录',
                width: 720,
                render: (h: any, params: any) => {
                    const row = params.row;
                    const stockList = row.planWarehouseStocks || [];
                    if (stockList.length === 0) {
                        return h('span', '暂无入库单记录');
                    }

                    // 1. 定义表格表头（横向展示的列名）
                    const tableHeader = [
                        '入库单号',
                        '物流单号',
                        '产品内码',
                        '产品数量',
                        '装箱数量',
                        '状态'
                    ];

                    // 2. 构建表格结构，取消maxHeight限制，overflow:auto保留（横向/纵向滚动自适应）
                    return h('div', { style: { overflow: 'auto' } }, [
                        // 表格容器（带边框，美观性优化）
                        h('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: '12px' } }, [
                            // 表头行
                            h('thead', [
                                h('tr', { style: { background: '#f5f5f5' } },
                                    tableHeader.map((header, idx) => {
                                        // 给不同表头设置对应宽度样式
                                        let thStyle = {
                                            border: '1px solid #eee',
                                            padding: '8px 5px',
                                            textAlign: 'center',
                                            whiteSpace: 'nowrap' // 表头不换行
                                        };
                                        // 针对性设置列宽
                                        switch (idx) {
                                            case 0: // 入库单号（第1列）：设置宽幅
                                                thStyle = { ...thStyle, width: '180px' } as any; // 适配长单号，可根据需求调整
                                                break;
                                            case 1: // 物流单号（第2列）：设置宽幅
                                                thStyle = { ...thStyle, width: '180px' } as any; // 适配长单号，可根据需求调整
                                                break;
                                            case 3: // 产品数量（第4列）：设置窄幅
                                                thStyle = { ...thStyle, width: '60px' } as any;
                                                break;
                                            case 4: // 装箱数量（第5列）：设置窄幅
                                                thStyle = { ...thStyle, width: '60px' } as any;
                                                break;
                                            // 产品内码、状态：默认宽度（自适应剩余空间）
                                            default:
                                                thStyle = { ...thStyle, width: '100px' } as any;
                                                break;
                                        }
                                        return h('th', { key: idx, style: thStyle }, header);
                                    })
                                )
                            ]),
                            // 表体行
                            h('tbody',
                                stockList.map((stock: any, index: number) => {
                                    const statusText = this.ProductStatus.find(item => item.value === stock.productStatus).name || '';

                                    // 1. 转换为数字类型，兼容空值/非数字值
                                    const productNums = Number(stock.productNums) || 0;
                                    const boxNumber = Number(stock.boxNumber) || 0;
                                    // 2. 判断产品数量与装箱数量是否不一致
                                    const isNumsMismatch = productNums !== boxNumber;
                                    // 3. 装箱数量单元格动态样式（不一致时红色加粗）
                                    const boxNumberTdStyle = {
                                        border: '1px solid #eee',
                                        padding: '8px 5px',
                                        textAlign: 'center',
                                        color: isNumsMismatch ? 'red' : 'inherit', // 不一致时红色
                                        fontWeight: isNumsMismatch ? 'bold' : 'normal' // 不一致时加粗
                                    };

                                    return h('tr', { key: index }, [
                                        // 入库单号列
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, stock.inStockNumber || ''),
                                        // 物流单号列
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, stock.logisticsNumber || ''),
                                        // 产品内码列
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, stock.productId || ''),
                                        // 产品数量列
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, `${productNums}`),
                                        // 装箱数量列（应用动态样式）
                                        h('td', { style: boxNumberTdStyle }, `${boxNumber}`),
                                        // 状态列
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center' } }, statusText)
                                    ]);
                                })
                            )
                        ])
                    ]);
                }
            },
            {
                title: '装箱记录',
                width: 440, // 移除用户ID列后，宽度从520px调整为440px（减少80px）
                render: (h: any, params: any) => {
                    const row = params.row;
                    // 保留原有数据来源，兼容首字母小写的返回结果
                    const packingList = row.planPackingDetails || row.packingDetailList || [];
                    if (packingList.length === 0) {
                        return h('span', '暂无装箱记录');
                    }

                    // 装箱记录表头：移除「用户ID」，保留4列
                    const packingHeader = ['箱号', '产品ID', '装箱数量', '装箱时间'];
                    // 统一清除默认间距，仅保留横向滚动（适配列宽不足场景）
                    return h('div', { style: { overflow: 'auto', margin: '0', padding: '0' } }, [
                        h('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: '12px', margin: '0', padding: '0' } }, [
                            h('thead', [
                                h('tr', { style: { background: '#f5f5f5', margin: '0', padding: '0' } },
                                    packingHeader.map((header, idx) => {
                                        let thStyle: any = {
                                            border: '1px solid #eee',
                                            padding: '8px 5px',
                                            textAlign: 'center',
                                            whiteSpace: 'nowrap',
                                            fontWeight: 'bold',
                                            margin: '0',
                                        };
                                        // 按列配置宽度（移除用户ID的80px配置，重新分配列宽）
                                        switch (idx) {
                                            case 0: thStyle.width = '50px'; break; // 箱号
                                            case 1: thStyle.width = '100px'; break; // 产品ID（适度加宽，提升显示效果）
                                            case 2: thStyle.width = '80px'; break; // 装箱数量
                                            case 3: thStyle.width = '170px'; break; // 装箱时间
                                            default: thStyle.width = '100px'; break;
                                        }
                                        return h('th', { key: idx, style: thStyle }, header);
                                    })
                                )
                            ]),
                            h('tbody',
                                packingList.map((packing: any, index: number) => {
                                    // 适配 DTO 数据，仅保留需要的字段（剔除userId）
                                    const boxNum = packing.boxNumber || 0;
                                    const productId = packing.productId || 0;
                                    const productNums = packing.productNums || 0;
                                    const createTime = packing.creationTime
                                        ? DateUtils.formatLongDate(new Date(packing.creationTime))
                                        : '';

                                    return h('tr', {
                                        key: index,
                                        style: {
                                            '&:hover': { background: '#fafafa' }, // hover 高亮
                                            margin: '0',
                                            padding: '0'
                                        }
                                    }, [
                                        // 移除用户ID对应的td，仅保留4列数据
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, boxNum),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, productId),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, productNums),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, createTime)
                                    ]);
                                })
                            )
                        ])
                    ]);
                }
            },
            {
                title: '操作',
                width: 180,
                fixed: 'right',
                render: (h: any, params: any) => {
                    const _this = this;
                    return h('div', [
                        // 编辑按钮
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                                icon: 'ios-create'
                            },
                            style: {
                                marginRight: '10px',
                                marginTop: '5px',
                                width: '80px'
                            },
                            on: {
                                click: () => {

                                    this.modify(params.row);
                                    //this.$store.commit('frontpreplan/setModel', params.row);
                                    //this.$nextTick(() => {
                                    //    this.modalShow = true;
                                    //});
                                    //    this.modalShow = true; // 直接使用 this，无需 _this

                                    // 存储当前行数据到vuex，供编辑组件使用
                                    //   _this.$store.commit('frontpreplan/setModel', params.row);
                                    //  _this.modalShow = true;
                                    //_this.add();
                                }
                            }
                        }, "编辑"),
                        // 删除按钮
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small',
                                icon: 'ios-trash'
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px'
                            },
                            on: {
                                click: () => {
                                    _this.deletePlan(params.row.id);
                                }
                            }
                        }, "删除")
                    ]);
                }
            }
        ];

        // 初始化仓库列表（含全部选项）
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            });
            // 构造“全部”仓库选项
            const allStoreOption: storeaddressInfo = {
                id: null, // null标识“全部”
                storeName: "全部",
                // 补充storeaddressInfo其他必填字段（根据你的实体定义补充，若无其他字段可忽略）
            } as storeaddressInfo;
            // 全部选项放在最前面
            this.storeaddressList = [allStoreOption, ...this.$store.state.backstoreaddress.list];
        }

        // 父组件 PrePlanManager 的 add 方法
        async add() {

            // 清空编辑模型，标识为新增
            this.$store.commit('frontpreplan/setModel', { id: 0 });
            // 移除 alert，避免阻塞弹窗渲染
            // alert(this.modalShow); // 注释/删除该行
            this.modalShow = true;
        }

        async modify(data) {
            this.$store.commit('frontpreplan/setModel', data);
            // 移除 alert，避免阻塞弹窗渲染
            // alert(this.modalShow); // 注释/删除该行
            this.modalShow = true;
        }

        // 分页切换
        pageChange(page: number) {
            this.$store.commit('frontpreplan/setCurrentPage', page);
            this.getpage();
        }

        // 每页条数切换
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontpreplan/setPageSize', pagesize);
            this.getpage();
        }

        // 搜索
        async searchPage() {
            this.$store.commit('frontpreplan/setCurrentPage', 1);
            this.getpage();
        }

        // 删除计划
        async deletePlan(id: number) {
            this.$Modal.confirm({
                title: "删除确认",
                content: "确定要删除该预备计划吗？删除后不可恢复！",
                onOk: async () => {
                    await this.$store.dispatch({
                        type: 'frontpreplan/delete',
                        data: { id }
                    });
                    this.$Message.success("删除成功！");
                    this.getpage();
                }
            });
        }

        // 获取列表数据
        async getpage() {
            // 组装查询参数
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            // 处理日期范围
            if (this.creationTime.length > 0) {
                this.pagerequest.startDate = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endDate = this.creationTime[1];
            }

            // 调用接口获取数据
            await this.$store.dispatch({
                type: 'frontpreplan/getAll',
                data: this.pagerequest
            });
        }

        // 页面创建时初始化
        async created() {
            await this.getData(); // 加载仓库列表（含全部）
            this.getpage(); // 加载计划列表
        }
    }
